module.exports = __webpack_public_path__ + "static/payment-608924babf3e3358c156dbe0ad3a11a8.png";